"use client";
import { cn as e } from "../../lib/utils.js";
import { CloseIcon as t } from "../../icons.js";
import { tv as n } from "tailwind-variants";
import { jsx as r, jsxs as i } from "react/jsx-runtime";
import { Dialog as a } from "@base-ui/react/dialog";
//#region src/components/Sheet/Sheet.tsx
var o = n({
	base: "ic-web-z-modal border-ic-web-border bg-ic-web-background font-ic-web-body text-ic-web-text fixed gap-4 border-solid p-6 shadow-lg transition-transform duration-300 ease-in-out outline-none",
	variants: { side: {
		top: "inset-x-0 top-0 border-b data-ending-style:-translate-y-full data-starting-style:-translate-y-full",
		bottom: "inset-x-0 bottom-0 border-t data-ending-style:translate-y-full data-starting-style:translate-y-full",
		left: "inset-y-0 left-0 h-full w-3/4 border-r data-ending-style:-translate-x-full data-starting-style:-translate-x-full sm:max-w-sm",
		right: "inset-y-0 right-0 h-full w-3/4 border-l data-ending-style:translate-x-full data-starting-style:translate-x-full sm:max-w-sm"
	} },
	defaultVariants: { side: "right" }
});
function s(e) {
	return /* @__PURE__ */ r(a.Root, { ...e });
}
function c(e) {
	return /* @__PURE__ */ r(a.Trigger, {
		"data-slot": "sheet-trigger",
		...e
	});
}
function l({ className: e, side: n, closeLabel: s = "Close", children: c, ...l }) {
	return /* @__PURE__ */ i(a.Portal, { children: [/* @__PURE__ */ r(a.Backdrop, {
		"data-slot": "sheet-overlay",
		className: "ic-web-z-modal bg-ic-web-overlay fixed inset-0 transition-opacity duration-300 data-ending-style:opacity-0 data-starting-style:opacity-0"
	}), /* @__PURE__ */ i(a.Popup, {
		"data-slot": "sheet-content",
		className: o({
			side: n,
			className: e
		}),
		...l,
		children: [c, /* @__PURE__ */ i(a.Close, {
			className: "focus-visible:ring-ic-web-primary/50 absolute top-4 right-4 cursor-pointer rounded-xs opacity-70 transition-opacity hover:opacity-100 focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none disabled:pointer-events-none",
			children: [/* @__PURE__ */ r(t, { className: "size-4" }), /* @__PURE__ */ r("span", {
				className: "sr-only",
				children: s
			})]
		})]
	})] });
}
function u({ className: t, ...n }) {
	return /* @__PURE__ */ r("div", {
		"data-slot": "sheet-header",
		className: e("flex flex-col gap-2 text-center sm:text-left", t),
		...n
	});
}
function d({ className: t, ...n }) {
	return /* @__PURE__ */ r("div", {
		"data-slot": "sheet-footer",
		className: e("flex flex-col-reverse gap-2 sm:flex-row sm:justify-end", t),
		...n
	});
}
function f({ className: t, ...n }) {
	return /* @__PURE__ */ r(a.Title, {
		"data-slot": "sheet-title",
		className: e("text-ic-web-heading text-lg font-semibold", t),
		...n
	});
}
function p({ className: t, ...n }) {
	return /* @__PURE__ */ r(a.Description, {
		"data-slot": "sheet-description",
		className: e("text-ic-web-text-muted text-sm", t),
		...n
	});
}
function m(e) {
	return /* @__PURE__ */ r(a.Close, {
		"data-slot": "sheet-close",
		...e
	});
}
var h = {
	Root: s,
	Trigger: c,
	Content: l,
	Header: u,
	Footer: d,
	Title: f,
	Description: p,
	Close: m
};
//#endregion
export { h as Sheet, o as sheetVariants };
